module.exports = __webpack_public_path__ + "spekit-wordmark-0cf27a3463a34ab5fc0d1a7d85f1fac8.svg";